import React from "react";
import {styled} from "@reside/ui";
import {ChecklistItem} from "@reside/reside-api-admission";

import {TaskCheckboxChildren} from "../../../task-checkbox-field";
import {IconButton} from "../../../icon-button";
import {
  ChecklistItemTextColumn,
  PccCheckboxRow,
} from "../cell/admission-checklist/style";

export const PccDocumentUploadTaskCheckbox = ({
  checklistItem,
  Checkbox,
  Label,
  onUpload,
}: TaskCheckboxChildren & {
  checklistItem: ChecklistItem;
  onUpload: (checklistItem: ChecklistItem) => void;
}) => {
  /**
   * Override default checkbox check, so we open document upload modal
   * right away when checking is attempted.
   */
  const checkboxProps = checklistItem.documentUploadRequired
    ? {
        onChange: () => onUpload(checklistItem),
      }
    : {};

  return (
    <>
      <RowWrapper>
        <PccCheckboxRow>
          <Checkbox {...checkboxProps} />
          <ChecklistItemTextColumn>
            <Label />
          </ChecklistItemTextColumn>
        </PccCheckboxRow>
        {checklistItem.pccDocumentUploaded ? (
          <StyledIconButton
            frameless
            iconName="file-pdf"
            color="mint100"
            onClick={() => onUpload(checklistItem)}
          />
        ) : checklistItem.documentUploadEnabled ? (
          <StyledIconButton
            frameless
            iconName="upload-cloud"
            onClick={() => onUpload(checklistItem)}
          />
        ) : null}
      </RowWrapper>
    </>
  );
};

const StyledIconButton = styled(IconButton)`
  margin-left: 5px;
  && {
    overflow: visible;
  }

  i {
    margin-right: 0;
  }
`;

const RowWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 6px;
`;
